<template>
  <div class="home-account">
    <div class="place-content-left">
      <div class="text-container" v-if="account">
        <div class="arrow-indicator" v-if="$route.name === 'Home'">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.5 18L15.5 12L9.5 6" stroke="#4285F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="account-header">
          <div class="account-number">№ {{ account.ls }}</div>
          <div class="account-street">{{ account.streetType }} {{ account.streetName }} {{ account.building }}</div>
          <template v-if="account.appartment">
            <div class="account-apartment">{{ $t("components.accounts.apartment") }} {{ account.appartment }}</div>
          </template>
          <div class="account-city">{{ account.city }}</div>
          <template v-if="showBalance">
            <div class="account-balance">
              Заборгованість: <span
                :class="
                  account.balance === 0
                    ? ''
                    : account.balance > 0
                    ? 'positive-balance'
                    : 'negative-balance'
                "
            >{{ Math.abs(account.balance) }}</span> {{ $t("components.accounts.currency") }}
            </div>
          </template>
        </div>
      </div>

      <!--      <template v-if="$route.name === 'Account'">-->
      <!--        <ul class="paynow-container">-->
      <!--          <li class="padding_x">-->
      <!--            <itserve-button-->
      <!--              :animated="true"-->
      <!--              class="mt-15 apply-loader mb-25"-->
      <!--              :value="$t('components.accounts.payNow')"-->
      <!--              @click="runPayment"-->
      <!--            />-->
      <!--          </li>-->
      <!--        </ul>-->
      <!--      </template>-->
      <!--      <simple-dialog-->
      <!--        v-model="showDialog"-->
      <!--        :success="true"-->
      <!--        :title="this.$t('pay.fees')"-->
      <!--        @change="runPayment"-->
      <!--      />-->
    </div>
  </div>
</template>
<script>
// import SimpleDialog from "@/components/content/SimpleDialog";
// import ItserveButton from "@/components/forms/ItserveButton";
// import Dialog from "vant/lib/dialog/index";
export default {
  name: "Account",
  components: {
    // ItserveButton,
    //SimpleDialog
  },
  props: {
    account: Object,
    type: {
      type: String,
      default: "regular",
    },
    showBalance: {
      type: Boolean,
      default: false,
    },
  },
  created () {},
  computed: {
    cards() {
      return this.$store.state.Payment.cards;
    },
    status() {
      return this.$store.state.Auth.status;
    }
  },
  data() {
    return {
      showDialog: false,
      limitStepOne: 300,
      limitStepTwo: 1000,
    };
  },
  methods: {
    getFee() {
      return this.account.balance < this.limitStepOne
          ? 3
          : this.account.balance >= 300 &&
          this.account.balance < this.limitStepTwo
              ? 3
              : this.account.balance > 1000
                  ? 3
                  : 3;
    },
    showNotification() {
      if (this.cards.length) {
        this.showDialog = true;
      } else {
        this.runPayment();
      }
    },
    async runPayment() {

      if(this.status === 1) {
        //let url = "https://easypay.ua/ua/catalog/utility/harkov/erc-communal-term?account=" + this.account.ls + "&submit=true";
        let url = "https://easypay.ua/ua/partner-frame/serve/catalog/utility/harkov";
        this.nativeSendEvent("url", url);
      }
      else{
        await this.$router.push({
          name: "PayAllNew",
          params: this.$route.params,
        });
      }
    },
  },
};
</script>

<style scoped>
.home-account {
  border-radius: 15px 15px 15px 15px;
  max-width: 377px;
  margin-top: -1px;
  box-shadow: none !important;
}

.home-account * {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
}

.place-content-left {
  padding: 15px 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.account-header {
  text-align: left;
  margin-bottom: 20px;
}

.account-number {
  font-size: 22px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #ffffff;
}

.account-street {
  font-size: 16px;
  line-height: 1.4;
  color: #ffffff;
  margin-bottom: 5px;
}

.account-apartment {
  font-size: 16px;
  line-height: 1.4;
  color: #ffffff;
  margin-bottom: 5px;
}

.account-city {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 5px;
}

.account-balance {
  font-size: 16px;
  margin-top: 5px;
  margin-bottom: 20px;
  color: #ffffff;
}

.positive-balance {
  color: #e3626e;
}

.negative-balance {
  color: #0f0;
}

.services-info-block {
  margin-top: 10px;
  text-align: left;
}

.service-block {
  margin-bottom: 25px;
}

.service-title {
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 5px;
  color: #ffffff;
}

.service-company {
  font-size: 16px;
  line-height: 1.4;
  color: #ffffff;
  margin-bottom: 6px;
}

.service-region, .service-note {
  font-size: 16px;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 6px;
}

.checkbox-group {
  margin-top: 15px;
}

.service-item {
  margin-bottom: 15px;
}

.checkbox-label {
  display: flex;
  align-items: flex-start;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
}

.checkbox-input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.service-label {
  display: flex;
  flex-direction: column;
}

.service-label span:first-child {
  font-weight: 500;
  color: #fff;
}

.service-label .account-number {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin: 3px 0;
}

.debt-amount {
  font-size: 14px;
}

.positive {
  color: #e3626e;
}

.negative {
  color: #4CD964;
}

.amount-input {
  margin-top: 10px;
  max-width: 200px;
}

/* Стили для чекбоксов */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: transparent;
  border: 2px solid #4285F4;
  border-radius: 3px;
}

.checkbox-label:hover .checkmark {
  border-color: #4477f6;
}

.checkbox-input:checked ~ .checkmark {
  background-color: #4285F4;
  border-color: #4285F4;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox-input:checked ~ .checkmark:after {
  display: block;
}

.checkbox-label .checkmark:after {
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.arrow-indicator {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0.7;
}

.home-account {
  position: relative;
}

</style>
